module.exports = __webpack_public_path__ + "static/media/you-are-what-your-food-eats.427f643b.jpg";